
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M359.765 415.765a23.931 23.931 0 01-16.971-7.028c-9.372-9.372-9.372-24.568 0-33.941 65.503-65.503 65.503-172.085 0-237.588-9.372-9.373-9.372-24.569 0-33.941 9.372-9.371 24.569-9.372 33.941 0C417.532 144.062 440 198.304 440 256s-22.468 111.938-63.265 152.735a23.921 23.921 0 01-16.97 7.03zM274.51 370.51a23.928 23.928 0 01-16.971-7.029c-9.373-9.373-9.373-24.567 0-33.94 40.55-40.55 40.55-106.529 0-147.078-9.373-9.373-9.373-24.569 0-33.941s24.568-9.372 33.941 0c59.265 59.265 59.265 155.696 0 214.961a23.93 23.93 0 01-16.97 7.027zM208.003 480a15.992 15.992 0 01-11.317-4.687L73.373 352H16c-8.836 0-16-7.163-16-16V176c0-8.836 7.164-16 16-16h57.373L196.686 36.686A16 16 0 01224 48v416a15.998 15.998 0 01-15.997 16z"}})])
          )
        }
      }
    